import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import Scrollbar from 'react-smooth-scrollbar'
import SmoothScrollbar, { ScrollbarPlugin } from 'smooth-scrollbar'

import { switchToXAxis, EdgeEasingPlugin } from './plugins'

// eslint-disable-next-line react/display-name
const WithScrollbar = ({ children, onInit, onDestroy, onScroll, ...props }) => {
  const scrollbarRef = useRef()

  useMemo(() => {
    class State extends ScrollbarPlugin {
      static pluginName = 'state'

      onInit() {
        onInit && onInit()
      }

      onDestroy() {
        onDestroy && onDestroy()
      }

      onUpdate() {
        // console.log(this) and detect if scrolling started or stopped (e.g. rAF or cAF loops)
        // console.log('horizontal scroller updated')
      }
    }
    // config plugins
    SmoothScrollbar.use(switchToXAxis, EdgeEasingPlugin, State)
  }, [])

  return (
    <Scrollbar ref={scrollbarRef} renderByPixels={false} alwaysShowTracks={false} {...props} onScroll={onScroll}>
      {children(scrollbarRef?.current || {})}
    </Scrollbar>
  )
}

WithScrollbar.propTypes = {
  onInit: PropTypes.func,
  onDestroy: PropTypes.func,
  onScroll: PropTypes.func,
}

WithScrollbar.whyDidYouRender = true

export default WithScrollbar
